import { SplashScreen } from '../../../components/partials/SplashScreen'
import { login } from '../redux/AuthService'

export function Login() {
  login()
  return (
    <SplashScreen></SplashScreen>
  )
}